var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Container, PageHeading } from '../../shared';
import { services } from '../../../shared';
import { APPLICATION } from '../../../config/routes';
import { SectionMenu } from '../../../components/sections/question-sets/section-menu/section-menu';
import { Workflow, SubmitCase, CaseNavigation } from '../../../components/sections';
import { workflowConstants } from '../../../shared/types/constants';
import { ApplicationFormStatus, BrokerStatus, OrganisationStatus } from '../../../shared/types/enums';
import { InactiveHandling } from '../../../components/pages';
import { defaultErrorResponse, hasError } from '../../../shared/types/service-handling';
import { useWorkflowStore } from '../../store/workflowStore';
import { useAppSelector } from '../../app/hooks';
export var applicationSubmitInitialState = {
    data: undefined,
    loading: false,
    error: false,
};
export var SubmitPage = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var location = _a.location;
    var _p = useParams(), caseId = _p.caseId, loanPurposeId = _p.loanPurposeId;
    var _q = useState([]), workflowSteps = _q[0], setWorkflowSteps = _q[1];
    var _r = useState([]), pages = _r[0], setPages = _r[1];
    var _s = useState(''), moduleText = _s[0], setModuleText = _s[1];
    var _t = useState(), currentStep = _t[0], setCurrentStep = _t[1];
    var _u = useState(false), menuVisible = _u[0], toggleMenuVisibility = _u[1];
    var _v = useState(), broker = _v[0], setBroker = _v[1];
    var _w = useState(applicationSubmitInitialState), shApplicationSubmit = _w[0], setShApplicationSubmit = _w[1];
    var removeWorkflow = useWorkflowStore(function (state) { return state.removeWorkflowStore; });
    var isAdmin = useAppSelector(function (state) { return state.adminData.adminData.isAdmin; });
    var sessionCaseId = useAppSelector(function (state) { return state.adminData.adminData.caseId; });
    var sessionFormId = useAppSelector(function (state) { return state.adminData.adminData.formId; });
    var sessionLoanPurposeId = useAppSelector(function (state) { return state.adminData.adminData.loanPurposeId; });
    var fetchPageWithStatus = function (caseId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var pageWithStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getPagesWithStatus(caseId, formId)];
                case 1:
                    pageWithStatus = (_a.sent()).data;
                    setPages(pageWithStatus);
                    return [2 /*return*/, pageWithStatus[0].sections[0].id];
            }
        });
    }); };
    // TODO: Fix this function, workout status usage
    var fetchCaseStatus = function (caseId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // const caseStatus: ApplicationStatus = (await services.getCase(caseId)).applicationStatusId;
            fetchModuleText(currentStep.applicationFormStatus);
            return [2 /*return*/];
        });
    }); };
    var fetchModuleText = function (status) { return __awaiter(void 0, void 0, void 0, function () {
        var code, moduleText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    code = '';
                    switch (status) {
                        case ApplicationFormStatus.Referred:
                        case ApplicationFormStatus.ReferredWaitingForMoreInfo:
                        case ApplicationFormStatus.ReferredWithMoreInfoSubmited:
                        case ApplicationFormStatus.CallValidateCallCreditRefer:
                        case ApplicationFormStatus.AutoRefer:
                            {
                                code = workflowConstants[currentStep.formTypeId].referred;
                            }
                            break;
                        case ApplicationFormStatus.Completed:
                        case ApplicationFormStatus.Completion:
                        case ApplicationFormStatus.Pass:
                            {
                                code = workflowConstants[currentStep.formTypeId].successful;
                            }
                            break;
                        case ApplicationFormStatus.Declined:
                        case ApplicationFormStatus.DeclinedWaitingForMoreInfo:
                        case ApplicationFormStatus.DeclinedWithMoreInfoSubmited:
                        case ApplicationFormStatus.AutoDeclineCancelled:
                        case ApplicationFormStatus.AutoDeclined:
                        case ApplicationFormStatus.AutoDeclinedWaitingForMoreInfo:
                        case ApplicationFormStatus.AutoDeclinedWithMoreInfoSubmited:
                            {
                                code = workflowConstants[currentStep.formTypeId].unsuccessful;
                            }
                            break;
                    }
                    return [4 /*yield*/, services.getModuleText(code)];
                case 1:
                    moduleText = (_a.sent()).data;
                    setModuleText(moduleText === null || moduleText === void 0 ? void 0 : moduleText.description);
                    return [2 /*return*/];
            }
        });
    }); };
    var submit = function () {
        fetchBrokerData();
        if (!(broker &&
            (broker.organisationStatusId == OrganisationStatus.Suspended ||
                broker.organisationStatusId == BrokerStatus.Pending))) {
            setShApplicationSubmit(__assign(__assign({}, shApplicationSubmit), { loading: true }));
            services.submitApplication(Number(caseId), currentStep.formId).then(function (result) {
                var _a;
                setShApplicationSubmit(result);
                var status = (_a = result.data) === null || _a === void 0 ? void 0 : _a.applicationStatus;
                currentStep.applicationFormStatus = status;
                var step = workflowSteps === null || workflowSteps === void 0 ? void 0 : workflowSteps.find(function (step) { return step.id == currentStep.id; });
                (step !== null && step !== void 0 ? step : currentStep).applicationFormStatus = status;
                setCurrentStep(currentStep);
                setWorkflowSteps(workflowSteps);
                fetchModuleText(status);
                removeWorkflow();
            });
        }
    };
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var id, caseDetailsData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = Number(caseId);
                    return [4 /*yield*/, services.getCase(id)];
                case 1:
                    caseDetailsData = _a.sent();
                    if (caseDetailsData === null || caseDetailsData === void 0 ? void 0 : caseDetailsData.data) {
                        location = {
                            state: {
                                loanPurposeId: caseDetailsData.data.loanPurposeId,
                                case: caseDetailsData.data,
                                applicants: caseDetailsData.data.applicants,
                            },
                        };
                    }
                    return [4 /*yield*/, fetchPageWithStatus(id, currentStep.formId)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, fetchCaseStatus(id)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchBrokerData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setBroker;
                    return [4 /*yield*/, services.getBroker()];
                case 1:
                    _a.apply(void 0, [(_b.sent()).data]);
                    return [2 /*return*/];
            }
        });
    }); };
    var rootPath = "".concat(APPLICATION.paths[0], "/").concat((_d = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : caseId, "/").concat((_f = (_e = location === null || location === void 0 ? void 0 : location.state) === null || _e === void 0 ? void 0 : _e.loanPurposeId) !== null && _f !== void 0 ? _f : Number(loanPurposeId), "/").concat(currentStep === null || currentStep === void 0 ? void 0 : currentStep.formId, "/");
    var restrictToRedirect = function (currentPath, sessionCaseId, sessionLoanPurposeId, sessionFormId) {
        var pathParts = currentPath.split('/');
        var currentCaseId = parseInt(pathParts[3]);
        var currentLoanPurposeId = parseInt(pathParts[4]);
        var currentFormId = parseInt(pathParts[5]);
        if (pathParts[pathParts.length - 1].toLowerCase() === 'illustrations'
            || pathParts[pathParts.length - 1].toLowerCase() === 'submit'
            || pathParts[pathParts.length - 1].toLowerCase() === 'complete') {
            return false;
        }
        return (currentCaseId === sessionCaseId &&
            currentLoanPurposeId === sessionLoanPurposeId &&
            currentFormId === sessionFormId);
    };
    useEffect(function () {
        var _a;
        if (isAdmin && !restrictToRedirect(window.location.pathname, Number(sessionCaseId), Number(sessionLoanPurposeId), Number(sessionFormId))) {
            window.open("".concat(window.location.origin, "/cases/application/").concat(sessionCaseId, "/").concat(sessionLoanPurposeId, "/").concat(sessionFormId), '_self');
        }
        else {
            fetchBrokerData();
            location.state = (_a = location.state) !== null && _a !== void 0 ? _a : {
                applicants: [],
                case: null,
                loanPurposeId: Number(loanPurposeId),
            };
            if (currentStep)
                fetchData();
        }
    }, [caseId, currentStep]);
    if (hasError([shApplicationSubmit])) {
        return defaultErrorResponse();
    }
    return (React.createElement(React.Fragment, null, broker &&
        (broker.organisationStatusId == OrganisationStatus.Suspended ||
            broker.organisationStatusId == BrokerStatus.Pending) ? (React.createElement(InactiveHandling, null)) : (React.createElement("div", null,
        React.createElement(Workflow, { caseId: (_j = (_h = (_g = location === null || location === void 0 ? void 0 : location.state) === null || _g === void 0 ? void 0 : _g.case) === null || _h === void 0 ? void 0 : _h.id) !== null && _j !== void 0 ? _j : Number(caseId), loanPurposeId: (_l = (_k = location === null || location === void 0 ? void 0 : location.state) === null || _k === void 0 ? void 0 : _k.loanPurposeId) !== null && _l !== void 0 ? _l : Number(loanPurposeId), setActiveWorkflowStep: setCurrentStep, setWorkflowSteps: setWorkflowSteps, location: location }),
        React.createElement("div", { className: "l-question-sets" },
            React.createElement("div", { className: "l-question-sets__toggle-menu" },
                React.createElement(Button, { type: "button", variant: "navy", icon: "chevronRight", iconPosition: "right", onClick: function () { return toggleMenuVisibility(!menuVisible); } }, "Open Steps")),
            React.createElement("div", { className: "l-question-sets__content" },
                React.createElement("div", { className: "l-question-sets__menu ".concat(menuVisible && 'isActive') },
                    React.createElement(SectionMenu, { pages: pages, rootPath: rootPath, location: location, workflowName: currentStep === null || currentStep === void 0 ? void 0 : currentStep.formType, closeMenu: toggleMenuVisibility })),
                React.createElement("div", { className: "l-question-sets-anchor-bg" }),
                React.createElement("div", { className: "l-question-sets__questions" },
                    React.createElement("div", { className: "l-question-sets__header" },
                        React.createElement(PageHeading, { headingLevel: 2, title: currentStep === null || currentStep === void 0 ? void 0 : currentStep.formType, icon: (_m = currentStep === null || currentStep === void 0 ? void 0 : currentStep.formType) === null || _m === void 0 ? void 0 : _m.toLowerCase(), mb: 6 })),
                    React.createElement(Container, { ctabar: true },
                        React.createElement("div", { className: "c-question-set" },
                            React.createElement(SubmitCase, { submitFunction: submit, formType: currentStep === null || currentStep === void 0 ? void 0 : currentStep.formType, applicationStatus: currentStep === null || currentStep === void 0 ? void 0 : currentStep.applicationFormStatus, pages: pages, moduleText: moduleText, caseId: Number(caseId !== null && caseId !== void 0 ? caseId : 0), formId: (_o = currentStep === null || currentStep === void 0 ? void 0 : currentStep.formId) !== null && _o !== void 0 ? _o : 0, steps: workflowSteps }),
                            [
                                ApplicationFormStatus.Completed,
                                ApplicationFormStatus.Completion,
                                ApplicationFormStatus.Pass,
                            ].includes(currentStep === null || currentStep === void 0 ? void 0 : currentStep.applicationFormStatus) && (React.createElement(CaseNavigation, { pages: pages, workflowSteps: workflowSteps, location: location })))))))))));
};
